import * as React from 'react';

import {StackLegacy} from '../layout/stack/stack-legacy';

import styles from './empty-timeline-cell.module.css';

type Props = {
    lineOneWidth: string;
    lineTwoWidth: string;
    contentWidth: string;
    contentHeight: string;
    noTopLine?: boolean;
};

export function EmptyTimelineCell(props: Props) {
    return (
        <StackLegacy spacing={8}>
            {!props.noTopLine ? <div className={styles['top-line']} /> : undefined}
            <div className={styles['container']}>
                <div className={styles['profile']} />
                <div className={styles['entryHeader']}>
                    <StackLegacy spacing={8}>
                        <div style={{width: props.lineOneWidth}} className={styles['row']} />
                        <div style={{width: props.lineTwoWidth}} className={styles['row']} />
                    </StackLegacy>
                </div>
            </div>
            <div className={styles['container']}>
                <div className={styles['line']} />
                <div
                    style={{height: props.contentHeight, width: props.contentWidth}}
                    className={styles['content']}
                />
            </div>
        </StackLegacy>
    );
}
